import {
  CATEGORY_ARCHIVE_SEGMENT,
  SHOW_CATEGORY_BASE_IN_SLUG,
  TAG_ARCHIVE_SEGMENT,
} from '@/constants/taxonomyRoutes'

/**
 * @param showCategoryBaseInSlug - Preferir valor do CMS / contexto; o defeito usa `NEXT_PUBLIC_SHOW_CATEGORY_BASE_IN_SLUG`.
 */
export function buildCategoryArchivePath(
  slug: string,
  showCategoryBaseInSlug: boolean = SHOW_CATEGORY_BASE_IN_SLUG,
  /** Preferir valor do CMS (`postUrlSettings.categoryUrlBase`); o defeito usa `NEXT_PUBLIC_CATEGORY_URL_BASE`. */
  categoryUrlBase: string = CATEGORY_ARCHIVE_SEGMENT,
): string {
  if (!showCategoryBaseInSlug) {
    return `/${slug}`
  }
  return `/${categoryUrlBase}/${slug}`
}

export function buildCategoryArchivePagePath(
  slug: string,
  page: number,
  showCategoryBaseInSlug: boolean = SHOW_CATEGORY_BASE_IN_SLUG,
  categoryUrlBase: string = CATEGORY_ARCHIVE_SEGMENT,
): string {
  const base = buildCategoryArchivePath(slug, showCategoryBaseInSlug, categoryUrlBase)
  if (page <= 1) return base
  return `${base}/page/${page}`
}

export function buildTagArchivePath(
  slug: string,
  /** Preferir valor do CMS (`postUrlSettings.tagUrlBase`); o defeito usa `NEXT_PUBLIC_TAG_URL_BASE`. */
  tagUrlBase: string = TAG_ARCHIVE_SEGMENT,
): string {
  return `/${tagUrlBase}/${slug}`
}

export function buildTagArchivePagePath(
  slug: string,
  page: number,
  tagUrlBase: string = TAG_ARCHIVE_SEGMENT,
): string {
  const base = buildTagArchivePath(slug, tagUrlBase)
  if (page <= 1) return base
  return `${base}/page/${page}`
}
